import { entities } from "sbtech-sports-data-api-client";
import { Scoreboard } from "../../data";
import { ParserHelper } from "../ParserHelper";

export class ScoreboardTennisParser {
    private static _instance: ScoreboardTennisParser;

    private readonly tennisScores: string[] = ["firstSetScore", "secondSetScore", "thirdSetScore", "fourthSetScore", "fifthSetScore"];
    private readonly scoresToDisplayForGamePart = { FirstSet: 1, SecondSet: 2, ThirdSet: 3, FourthSet: 4, FifthSet: 5 };

    private constructor() { }

    public static get instance(): ScoreboardTennisParser {
        if (!ScoreboardTennisParser._instance) {
            ScoreboardTennisParser._instance = new ScoreboardTennisParser();
        }
        return ScoreboardTennisParser._instance;
    }

    public parse(sportEvent: entities.SportEvent): Scoreboard {
        let onServe: string | undefined = ParserHelper.instance.getAdditionalScore(sportEvent, "onServe");
        let currentTennisScores: string[] = [];

        if (sportEvent.liveGameState && sportEvent.liveGameState.gamePart) {
            let scoreCount =  this.scoresToDisplayForGamePart[sportEvent.liveGameState.gamePart];
            currentTennisScores = this.tennisScores.slice(0, scoreCount);
        }

        let additionalScoreData1: string[] =
            ParserHelper.instance.getAdditionalScores(sportEvent, currentTennisScores, "1");
        let additionalScoreData2: string[] =
            ParserHelper.instance.getAdditionalScores(sportEvent, currentTennisScores, "2");

        if (sportEvent.isTeamSwap) {
            return {
                onServe: this.swapOnServe(onServe),
                additionalScoreData1: additionalScoreData2,
                additionalScoreData2: additionalScoreData1
            }
        }

        return {
            onServe,
            additionalScoreData1,
            additionalScoreData2
        }
    }

    private swapOnServe(onServe: string | undefined): string | undefined {
        switch (Number(onServe)) {
            case 1: return "2";
            case 2: return "1";
        }

        return undefined;
    }
};
